<template>
	<div >
		<Row style="padding-top: 20px;">
			<Form :label-width="80">
				<FormItem label="时间选择">
					<DatePicker type="month" placeholder="请选择月份" style="width: 200px" v-model="startTime"
				@on-change="onChangeStart"></DatePicker>
				<Button @click="initSearch" type="primary" style="margin-left: 20px;">重置刷新</Button>
				</FormItem>
				<FormItem label="条件选择">
					<Select v-model="shop_id" style="width:200px;margin-left: 20px;" clearable placeholder="跟进分公司" @on-change="mySearch">
						<Option v-for="item in shopList" :value="item.value" :key="item.value">{{ item.label }}</Option>
					</Select>
					<Select v-model="city" style="width:200px;margin-left: 20px;" clearable placeholder="城市" @on-change="mySearch">
						<Option v-for="item in cityList" :value="item.city" :key="item.city">
							{{ item.city }}
						</Option>
					</Select>
				</FormItem>
			</Form>
		</Row>
		<div style="height: 500px; overflow-y: auto; overflow-x: hidden">
			<Table border :columns="columns" :data="datas" height="500">
				<template slot-scope="{ row,index }" slot="repay_money_rate0">
					<div v-if="row.all_repay_money !=0">
						<span style="color: #be00be;">{{((row.repay_money0/row.all_repay_money)*100).toFixed(0)}}%</span>
					</div>
					<div v-if="row.all_repay_money ==0">
						<span style="color: #be00be;">0%</span>
					</div>
				</template>
				<template slot-scope="{ row,index }" slot="repay_money_rate1">
					<div v-if="row.all_repay_money !=0">
						<span style="color: #be00be;">{{((row.repay_money1/row.all_repay_money)*100).toFixed(0)}}%</span>
					</div>
					<div v-if="row.all_repay_money ==0">
						<span style="color: #be00be;">0%</span>
					</div>
				</template>
				<template slot-scope="{ row,index }" slot="repay_money_rate2">
					<div v-if="row.all_repay_money !=0">
						<span style="color: #be00be;">{{((row.repay_money2/row.all_repay_money)*100).toFixed(0)}}%</span>
					</div>
					<div v-if="row.all_repay_money ==0">
						<span style="color: #be00be;">0%</span>
					</div>
				</template>
				<template slot-scope="{ row,index }" slot="repay_money_rate3">
					<div v-if="row.all_repay_money !=0">
						<span style="color: #be00be;">{{((row.repay_money3/row.all_repay_money)*100).toFixed(0)}}%</span>
					</div>
					<div v-if="row.all_repay_money ==0">
						<span style="color: #be00be;">0%</span>
					</div>
				</template>
				<template slot-scope="{ row,index }" slot="repay_money_rate4">
					<div v-if="row.all_repay_money !=0">
						<span style="color: #be00be;">{{((row.repay_money4/row.all_repay_money)*100).toFixed(0)}}%</span>
					</div>
					<div v-if="row.all_repay_money ==0">
						<span style="color: #be00be;">0%</span>
					</div>
				</template>
				<template slot-scope="{ row,index }" slot="repay_money_rate5">
					<div v-if="row.all_repay_money !=0">
						<span style="color: #be00be;">{{((row.repay_money5/row.all_repay_money)*100).toFixed(0)}}%</span>
					</div>
					<div v-if="row.all_repay_money ==0">
						<span style="color: #be00be;">0%</span>
					</div>
				</template>
				<template slot-scope="{ row,index }" slot="repay_money_rate6">
					<div v-if="row.all_repay_money !=0">
						<span style="color: #be00be;">{{((row.repay_money6/row.all_repay_money)*100).toFixed(0)}}%</span>
					</div>
					<div v-if="row.all_repay_money ==0">
						<span style="color: #be00be;">0%</span>
					</div>
				</template>
			</Table>			
		</div>

	</div>
</template>

<script>
	import {
		getCompanyMonthConversion
	} from "../../api/statics.js";
	import {getAllCity,getAllShop} from "../../api/runSet";
	import {
		mapGetters,
		mapActions
	} from "vuex";
	export default {
		name: "synthesize_analyse",
		components: {

		},
		props: ['timePeriod', 'timePeriodDate', 'adid'],
		data() {
			return {
				columns: [{
					"title": "渠道",
					"key": "medium_name",
					"align": 'center',
					"width":'150px'
				},{
					"title": "合计",
					"key": "all_repay_money",
					"align": 'center',
					"width":'70px'
				}],
				datas: [],
				startTime:null,
				shopList:[],
				shop_id:'',
				city:'',
				cityList:'',
				order_type: 'desc'
			};
		},
		computed: {
			...mapGetters(['token', 'userInfo'])
		},
		watch: {
			adid() {
				this.getList();
			},
		},
		mounted() {
			this.getCurrentDate();
			this.loadData();
			this.getList();
		},
		methods: {
			...mapActions([
				'handleLogOut',
				'getUserInfo',
			]),
			async loadData() {
				let that = this;
				var data = {
					token: that.token,
				};
				var res = await getAllShop(that, data);
				that.shopList = res.data.list;
				res = await getAllCity(that, data);
				that.cityList = res.data.list;
				for (let i = 0; i < 7; i++) {
					var data1 = {};
					data1.title = 'M' + i;
					if(i ==6){
						data1.title = 'M6+'
					}
					data1.align = "center";
					data1.children = [
						{
							title: '创收',
							key: 'repay_money'+i,
							align: 'center',
							width:'70px'
						},
						{
							title: '占比',
							slot: 'repay_money_rate'+i,
							align: 'center',
						}
					];
					that.columns.splice(i + 2, 0, data1); //从数组的第二项开始插入
				}
				console.log(that.columns);
			},
			onChangeStart(date) {
				console.log(date)
				this.startTime = date;
				this.getList();
			},
			mySearch() {
				this.getList();
			},
			initSearch(){		
				this.shop_id = '';
				this.city = '';
				this.getCurrentDate();
				this.getList();
			},
			getCurrentDate() {
				var date = new Date();
				var year = date.getFullYear();
				var month = date.getMonth() + 1;
				month = month > 9 ? month : "0" + month;
				var nowMonth = year + "-" + month;
				this.startTime = nowMonth
			},
			async getList() {
				let that = this;
				let data = {
					startTime: that.startTime,
				}
				data.token = that.token;
				data.shop_id = that.shop_id;
				data.city = that.city;
				let res = await getCompanyMonthConversion(that, data);
				that.datas = res.data.list;
			},
		},
	};
</script>

<style lang="less" scoped>
	
	.multiple {
		display: flex;
		justify-content: left;
		margin-top: 10px;
		align-items: center;
	
		.child-div {
			width: 70px;
			height: 20px;
			margin-right: 30px;
			text-align-last: justify;
		}
	}
	/deep/ .ivu-table th {
		background: #277dd3;
		color: white;
	}

	/deep/ .ivu-table .table-blue-row td {
		color: #ff6699;
	}

	/deep/ .ivu-table .table-yellow-row td {
		color: #aaaa00;
	}

	/deep/ .ivu-table .table-black-row td {
		color: black;
	}
</style>
